const jsonURL = "https://leadersinternational.org/wp-json/wp/v2";
const ajaxURL = "https://leadersinternational.org/wp-admin/admin-ajax.php";

export const getProjects = async () => {
  let projects = await fetch(
    jsonURL +
      "/posts?categories=22&status=publish&per_page=100&page=1&_embed&_fields=title,link,country,featured_image_url,featured_media"
  )
    .then((res) => {
      return res.json();
    })
    .then((d) => {
      return d;
    });
  return projects;
};

export const getCountries = async () => {
  let formData = new FormData();
  formData.append("action", "project_countries");

  let requestOptions = {
    method: "POST",
    body: formData,
    redirect: "follow",
  };

  let fetchCountries = await fetch(ajaxURL, requestOptions)
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));

  return fetchCountries;
};
